import React from "react";
import Button from "@Components/Button";
import MapIcon from "@Icons/MapIcon";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";

import styles from "./MapToggleButton.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import getImagePath from "@Utils/getImagePath";
import useTranslationHook from "hooks/useTranslationHook";

interface MapToggleButtonProps {
  onClick: () => void;
  showMap: boolean;
  style?: React.CSSProperties;
}

const defaultStaticMapUrl =
  "https://assets.dev-amber.com/regions/14/0ac51277.jpg?auto=compress&trim=auto";
const DEFAULT_COLOR = "#f3123c";
const WHITELABEL_BUTTON_COLOR = "#000000";

const MapToggleButton: React.FC<MapToggleButtonProps> = ({ onClick, showMap, style }) => {
  const { region, isWhitelabel, whitelabelColors } = useSelector(
    ({ searchPageData, whitelabelData }: AppState) => ({
      region: searchPageData.region,
      isWhitelabel: whitelabelData.isWhitelabel,
      whitelabelColors: whitelabelData.colors,
    }),
    shallowEqual,
  );
  const staticMapUrl = region?.meta?.static_map_url || defaultStaticMapUrl;
  const { t } = useTranslationHook();
  const mapIconColor =
    isWhitelabel && whitelabelColors?.cta_color ? whitelabelColors.cta_color : DEFAULT_COLOR;

  const buttonStyle = isWhitelabel
    ? { borderColor: WHITELABEL_BUTTON_COLOR, color: WHITELABEL_BUTTON_COLOR }
    : { borderColor: DEFAULT_COLOR, color: DEFAULT_COLOR };

  return (
    <div
      className={styles.mapButtonContainer}
      style={{
        ...style,
        backgroundImage: `url(${getImagePath(staticMapUrl, "", { h: 600 })})`,
      }}
      onClick={onClick}
      role="none"
    >
      <Button
        type="button"
        onClick={onClick}
        variant="outline"
        className={styles.mapButton}
        style={buttonStyle}
      >
        <MapIcon fill={mapIconColor} size="20" />
        <span className={styles.buttonText}>
          {showMap
            ? t("searchpage.components.maptogglebutton.hidemap")
            : t("searchpage.components.maptogglebutton.exploreonmap")}
        </span>
      </Button>
    </div>
  );
};

export default wrapperHOC(MapToggleButton, {
  componentName: "MapToggleButton",
  showForChina: true,
});
